import styles from "./Tags.module.scss";
import Link from "next/link";
import { blog as blogConfig } from "~/config/blog";

export default function Tags({ post }) {
  return (
    <section className={styles["Tags"]}>
      <ul className={styles["Tags__list"]}>
        {post.tags
          .filter((tag) => tag.visibility == "public")
          .map((tag) => {
            return (
              <li className={styles["Tags__item"]}>
                <Link
                  href={`${blogConfig.baseUrl}${tag.slug}`}
                  className={styles["Tags__item-link"]}
                >
                  {tag.name}
                </Link>
              </li>
            );
          })}
      </ul>
    </section>
  );
}
